import Vue from 'vue'
import App from './App'
import router from './router'
import AsyncComputed from 'vue-async-computed'

Vue.use(AsyncComputed)

import api from 'api'
import ReactiveDaoVue from 'reactive-dao-vue'
Vue.use(ReactiveDaoVue, {
  dao: api
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js